import React, { useState, useEffect } from 'react';
import * as Utils from '../../services/utils';

function Typing(props) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
      Utils.scrollToTop();
    }, props.wait);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`bubble-typing ${show ? 'show' : ''}`}>
      <div className="typing">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    </div>
  );
}

export default Typing;
